import _defineProperty from "@babel/runtime/helpers/defineProperty";
/*
 *                     NOTICE
 *            COPYRIGHT 2018 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

import { Assert } from "abweb/utils/Assert";

// Manages add/remove of listeners, but up to subclass on how to process them

export class CallbackHolder {
  constructor() {
    _defineProperty(this, "listeners", new Array());
    this.addCallback = this.addCallback.bind(this);
    this.removeCallback = this.removeCallback.bind(this);
    this.removeAllCallbacks = this.removeAllCallbacks.bind(this);
    this.hasListener = this.hasListener.bind(this);
  }

  /**
   * Add a subscriber.
   * The subscriber can be removed later either by calling removeListener, or by stashing away the IUnsubscriber.
   * Returns a IUnsubscriber object that can optionally be saved for later.
   */
  addCallback(listener) {
    this.listeners.push(listener);

    // return an IUnsubscriber that can be stored to remove the listener later.
    return () => this.removeCallback(listener);
  }

  /**
   * @param listener
   */
  removeCallback(listener) {
    const index = this.listeners.indexOf(listener);
    if (index !== -1) {
      this.listeners.splice(index, 1);
    } else {
      // removing a listener that was never added is certainly a mistake in program logic
      Assert.unexpected("mistake in program logic - removeListener without previous addListener");
    }
  }
  removeAllCallbacks() {
    this.listeners.length = 0; // clears all array entries
  }
  hasListener(listener) {
    return this.listeners.indexOf(listener) >= 0;
  }

  /**
   * listener count is exposed to aid debugging.
   */
  get listenerCount() {
    return this.listeners.length;
  }

  /** Return copy (defensive) of current listeners, suitable for iterating over by child classes */
  getCallbacks() {
    return this.listeners.slice(0);
  }
}
//# sourceMappingURL=CallbackHolder.js.map
